import { AppSidebar } from "../components/dashboard/app-sidebar"
import { SiteHeader } from "../components/dashboard/site-header"
import { Outlet } from "react-router-dom"
import {
  SidebarInset,
  SidebarProvider,
} from "@/components/ui/sidebar"

import data from "../pages/dashboard/data.json"

export default function Dashboard() {
  return (
    <SidebarProvider
      style={
        {
          "--sidebar-width": "calc(var(--spacing) * 60)",
          "--header-height": "calc(var(--spacing) * 20)",
        } as React.CSSProperties
      }
    >
      <AppSidebar variant="inset" />
      <SidebarInset className="!m-0 !rounded-none !shadow-none !bg-transparent">
        <SiteHeader />
        <div className="flex flex-1 flex-col m-2 mt-0 rounded-xl bg-background shadow overflow-hidden">
          <div className="flex flex-1 flex-col p-4">
            <div className="@container/main flex flex-1 flex-col gap-2 h-full">
              <Outlet />
            </div>
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
